import React from 'react';

export type CompanyInfo = {
  company_name: string;
  url: string;
};

type BulkUploadPreviewProps = {
  companies: CompanyInfo[];
  onClear: () => void;
};

const BulkUploadPreview: React.FC<BulkUploadPreviewProps> = ({ companies }) => {
  if (!companies.length) return null;

  return (
    <div className="flex flex-col gap-4 border border-gray-200 rounded-sm p-4 bg-gray-50">
      <div className="overflow-hidden">
        <div
          className="max-h-[200px] overflow-y-auto pr-2"
          style={{ scrollbarGutter: 'stable' }}
        >
          <table className="w-full">
            <thead className="bg-gray-50 sticky top-0 z-10">
              <tr>
                <th className="text-left p-3 text-small font-medium text-gray-600 bg-gray-100">
                  Company Name
                </th>
                <th className="text-left p-3 text-small font-medium text-gray-600 bg-gray-100">
                  URL
                </th>
              </tr>
            </thead>
            <tbody>
              {companies.map((company, index) => (
                <tr key={index} className="border-t border-gray-200">
                  <td className="p-3 text-small">{company.company_name}</td>
                  <td className="p-3 text-small">{company.url}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BulkUploadPreview;
